import React from 'react'
import CommentsCount from '../../cards/TheNightly/components/card-body/byline/CommentsCount'
import { StyledCommentsWrapper, StyledTextLink } from './CommentButton.styled'

export type CommentsButtonProps = {
    url?: string
}

export const CommentButtonTN: React.FC<CommentsButtonProps> = ({
    ...props
}: CommentsButtonProps) => {
    return (
        <StyledCommentsWrapper>
            <CommentsCount articleUrl={props.url} size={24} />
            <StyledTextLink href={'#coral_thread'}>Comments</StyledTextLink>
        </StyledCommentsWrapper>
    )
}
